import React, { useState } from 'react';

// Chips: selección única o múltiple
const Chips = ({ pregunta, answer, onAnswer }) => {
  const { multiple, opciones = [] } = pregunta;
  const selectedIds = multiple ? (answer?.selectedIds || []) : [];
  const selectedId  = !multiple ? (answer?.selectedId || null) : null;
  const textoLibre  = answer?.textoLibre || '';

  const toggle = (opcion) => {
    if (opcion.esTextoLibre) {
      if (multiple) {
        const next = selectedIds.includes('otro')
          ? selectedIds.filter(id => id !== 'otro')
          : [...selectedIds, 'otro'];
        onAnswer({ selectedIds: next, textoLibre });
      } else {
        onAnswer({ selectedId: selectedId === 'otro' ? null : 'otro', textoLibre });
      }
      return;
    }
    if (multiple) {
      const next = selectedIds.includes(opcion.id)
        ? selectedIds.filter(id => id !== opcion.id)
        : [...selectedIds, opcion.id];
      onAnswer({ selectedIds: next, textoLibre });
    } else {
      onAnswer({ selectedId: opcion.id, valor: opcion.valor ?? opcion.id });
    }
  };

  const isSelected = (opcion) =>
    multiple ? selectedIds.includes(opcion.id) : selectedId === opcion.id;

  const showTextoLibre = multiple
    ? selectedIds.includes('otro')
    : selectedId === 'otro';

  return (
    <div className="space-y-2.5">
      <div className="flex flex-wrap gap-2">
        {opciones.map(opcion => (
          <button
            key={opcion.id}
            type="button"
            onClick={() => toggle(opcion)}
            className={`flex items-center gap-1.5 px-3 py-2 rounded-xl border-2 text-sm font-semibold transition-all select-none ${
              isSelected(opcion)
                ? 'border-red-500 bg-red-50 text-red-700 shadow-sm'
                : 'border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50'
            }`}
          >
            {opcion.emoji && <span className="text-base leading-none">{opcion.emoji}</span>}
            <span>{opcion.label}</span>
            {isSelected(opcion) && !multiple && (
              <span className="ml-0.5 text-red-500 text-xs font-bold">✓</span>
            )}
          </button>
        ))}
      </div>

      {showTextoLibre && (
        <textarea
          autoFocus
          className="w-full px-3 py-2 border-2 border-red-300 rounded-xl text-sm outline-none focus:border-red-500 resize-none bg-red-50 placeholder-red-300"
          placeholder="Describe el problema con tus palabras..."
          rows={2}
          value={textoLibre}
          onChange={e => {
            if (multiple) {
              onAnswer({ selectedIds, textoLibre: e.target.value });
            } else {
              onAnswer({ selectedId: 'otro', textoLibre: e.target.value });
            }
          }}
          onKeyDown={e => e.stopPropagation()}
        />
      )}

      {multiple && selectedIds.filter(id => id !== 'otro').length > 0 && (
        <p className="text-xs text-gray-400">
          {selectedIds.filter(id => id !== 'otro').length} seleccionado{selectedIds.filter(id => id !== 'otro').length !== 1 ? 's' : ''}
          {textoLibre && ' + nota libre'}
        </p>
      )}
    </div>
  );
};

export default Chips;
